<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M436 284c6.6 0 12-5.4 12-12v-32c0-6.6-5.4-12-12-12H12c-6.6 0-12 5.4-12 12v32c0 6.6 5.4 12 12 12h424z"/></svg>
</template>